import IIIFResources from "./IIIFResources.js";
import { Subject } from "rxjs";

const _debug = true;

const _zoomSpeed = 1.2;
const _scrollSpeed = 0.0008;
const _imageScrollOffset = 0.5;

class Sequence {

    constructor(viewer, zoomControls) {
        this.viewer = viewer;
        this.zoomControls = zoomControls;
        this.onCurrentImageChange = new Subject();
        this.onScroll = new Subject();
        this.minY = 0;
        this.maxY = 0;
    }

    initialize(currentImageId) {
        this.viewer.openseadragon.zoomPerScroll = 1; //disable zoom per scroll
        currentImageId ?? _getImageId(this.getImageAtIndex(0));
        this.imageLocations = _initImageLocations(this);
        this.setCurrentImage(currentImageId, true, true);
        _handleMouseWheel(this, this.zoomControls);
        this.viewer.openseadragon.addHandler('pan', event => _updateCurrentImage(this, event));
    }
 
    getCurrentImageBounds() {
        let bounds = this.imageLocations.get(this.currentImageId)?.getBounds();
        if(bounds ) {
            return bounds.clone();
        } else {
            return this.getImageAtIndex(0).getBounds().clone();
        }
    }

    getImageAtIndex(index) {
        return this.viewer?.openseadragon?.world?.getItemAt(index)
    }

    getImageById(imageId) {
        return this.imageLocations.get(imageId);
    } 

    getIndexOfImage(image) {
        return this.viewer?.openseadragon.world.getIndexOfItem(image);
    }


    setCurrentImage(id, goHome, immediate) {
        if(this.currentImageId != id) {
            this.currentImageId = id;
            const imageIndex = this.getCurrentImageIndex();
            if(imageIndex > -1) {
                if(_debug) console.log("Set current image to ", id, imageIndex);
                this.viewer.setCurrentImage(imageIndex);
                if(goHome) {
                    this.zoomControls?.goHome(immediate);
                }
                this.onCurrentImageChange.next({id:this.currentImageId, index:imageIndex});
                this.onScroll.next({deltaY:0});
            }
        }
    }
         
    getImageIdAtPosition(y) {
        if(this.imageLocations == undefined) {
            this.imageLocations = _initImageLocations(this);
        }
        let imageId = this.imageLocations.keys().next();
        for(let entry of this.imageLocations) {
            let id = entry[0];
            let bounds = entry[1]?.getBounds();
            if(y < bounds.y + _imageScrollOffset ) {
                return imageId;
            } else {
                imageId = id;
            }
        }

        //in case no image was found, i.e. we are outside the image bounds
        if(y <= 0) {
            return this.imageLocations.keys().next();
        } else {
            return this.imageLocations.keys().toArray().pop();
        }
    }

    getCurrentImageIndex() {
        const image = this.getImageById(this.currentImageId);
        const index =  this.getIndexOfImage(image);
        return index;
    }

    getNumImages() {
        return this.imageLocations?.size;
    }

}

function _updateCurrentImage(sequence, event) {
    if(event.immediately) {
        return;
    }
    let y = event.center.y;
    //if ( _debug ) console.log("panned viewer to ", y);
    let newImageId = sequence.getImageIdAtPosition(y);
    if(newImageId != sequence.currentImageId) {
        sequence.setCurrentImage(newImageId);
    }
    //if ( _debug ) console.log("Current image id ", sequence.currentImageId);
}

function _getImageId(image) {
    return IIIFResources.getId(image?.source) || image?.source?.url;
}

function _handleMouseWheel(sequence, zoomControls) {
    sequence.viewer?.element?.addEventListener("wheel", wheelEvent => {
        //if(_debug)console.log("scroll event ", wheelEvent);
        if(wheelEvent.ctrlKey || sequence.getNumImages() < 2) {
            if( wheelEvent.deltaY < 0 || !zoomControls.isZoomedOut() ) {
                zoomControls?.zoomBy(wheelEvent.deltaY > 0 ? 1/_zoomSpeed : _zoomSpeed, wheelEvent);
            } else {
                zoomControls?.goHome(); 
            }
        } else if(wheelEvent.deltaY < 0 && sequence.viewer.openseadragon.viewport.getBounds().y < sequence.minY) {
            zoomControls?.goHome();
            sequence.onScroll.next(wheelEvent);
        } else if(wheelEvent.deltaY > 0 && sequence.viewer.openseadragon.viewport.getBounds().y > sequence.maxY) {
            zoomControls?.goHome();
            sequence.onScroll.next(wheelEvent);
        } else {
            sequence.viewer.openseadragon.viewport.panBy({x:0,y: wheelEvent.deltaY * _scrollSpeed}, false);
            sequence.onScroll.next(wheelEvent);
        }
        wheelEvent.preventDefault();
    }); 
}

function _initImageLocations(sequence) {
    const locations = new Map();
    for (let index = 0; index < sequence.viewer.openseadragon.world.getItemCount(); index++) {
        const item = sequence.viewer.openseadragon.world.getItemAt(index);
        const id = _getImageId(item);
        locations.set(id, item);
        sequence.maxY = Math.max(sequence.maxY, item.getBounds().y);
    }
    if ( _debug ) console.log("init locations ", locations);
    return locations;
}

export default Sequence;

